import type { CharacterId } from '../../../domain/ids/ids';
import type { GiantId } from '../../../domain/ids/ids';
import type { LevelRunSnapshot } from '../../store/settleLevelRun';

export type LevelScreenProps = {
  giantId?: GiantId;
  characterId?: CharacterId;
  orderIndex?: number;
  levelKey?: number;
  isPaused?: boolean;
  health?: number;
  maxHealth?: number;
  collectiblesCollected?: number;
  collectiblesTotal?: number;
  progress?: number;
  onPause?: () => void;
  onSuccess?: (snapshot: LevelRunSnapshot) => void;
  onFail?: (snapshot: LevelRunSnapshot) => void;
};

export type LevelScreenModel = {
  giantId: GiantId;
  orderIndex: number;
  health: number;
  maxHealth: number;
  collectiblesCollected: number;
  collectiblesTotal: number;
  progress: number;
  onPause?: () => void;
  onSuccess?: (snapshot: LevelRunSnapshot) => void;
  onFail?: (snapshot: LevelRunSnapshot) => void;
};

export function createLevelScreenModel(props: LevelScreenProps): LevelScreenModel {
  return {
    giantId: props.giantId ?? 'mona',
    orderIndex: props.orderIndex ?? 0,
    health: props.health ?? 4,
    maxHealth: props.maxHealth ?? 5,
    collectiblesCollected: props.collectiblesCollected ?? 0,
    collectiblesTotal: props.collectiblesTotal ?? 0,
    progress: props.progress ?? 0,
    onPause: props.onPause,
    onSuccess: props.onSuccess,
    onFail: props.onFail,
  };
}
